import React from 'react';
import { Typography, theme } from 'antd';
import { FontSizeOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { IconAdd } from './reportingIcons';

const { Text } = Typography;

function PlaceholderBox({ icon, label, onClick, width, height }) {
    const { token } = theme.useToken();
    return (
        <div
            onClick={onClick}
            role="button"
            tabIndex={0}
            onKeyDown={e => e.key === 'Enter' && onClick()}
            style={{
                width,
                height,
                border: `2px dashed ${token.colorBorder}`,
                borderRadius: 12,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                color: token.colorTextSecondary,
                transition: 'border-color 0.2s, color 0.2s',
                outline: 'none',
                flexShrink: 0,
            }}
            onMouseEnter={e => {
                e.currentTarget.style.borderColor = token.colorPrimary;
                e.currentTarget.style.color = token.colorPrimary;
            }}
            onMouseLeave={e => {
                e.currentTarget.style.borderColor = token.colorBorder;
                e.currentTarget.style.color = token.colorTextSecondary;
            }}
        >
            {icon}
            <Text type="secondary" style={{ marginTop: 10, fontSize: 14, color: 'inherit' }}>
                {label}
            </Text>
        </div>
    );
}

/** Dashed placeholders to add a text section (modal) or a chart (drawer). */
export default function AddLayoutPlaceholders({ onAddText, onAddChart, size = 'large' }) {
    const { t } = useTranslation();
    const dims = size === 'large'
        ? { w: 200, h: 120, icon: 32 }
        : { w: 160, h: 100, icon: 26 };

    return (
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'stretch' }}>
            <PlaceholderBox
                width={dims.w}
                height={dims.h}
                label={t('Add text')}
                onClick={onAddText}
                icon={<FontSizeOutlined style={{ fontSize: dims.icon, opacity: 0.5 }} />}
            />
            <PlaceholderBox
                width={dims.w}
                height={dims.h}
                label={t('Add chart')}
                onClick={onAddChart}
                icon={<IconAdd style={{ fontSize: dims.icon, opacity: 0.45 }} />}
            />
        </div>
    );
}
